/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconUserPlus = createReactComponent("user-plus", "IconUserPlus", [
  ["path", { d: "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0", key: "svg-0" }],
  ["path", { d: "M16 19h6", key: "svg-1" }],
  ["path", { d: "M19 16v6", key: "svg-2" }],
  ["path", { d: "M6 21v-2a4 4 0 0 1 4 -4h4", key: "svg-3" }]
]);

export { IconUserPlus as default };
//# sourceMappingURL=IconUserPlus.js.map
